import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class VoidButtonModel extends ButtonBase {
    label: string = 'Void';
    action: string = ACTION_STATUS.void;
    matIconName: string = 'money_off';
    colorClass: string = 'color-primary-500';
}